module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-item ui modal segment"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("New Item")]), _vm._m(0), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui cancel button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _c('div', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.add_item
    }
  }, [_vm._v("Add")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Label")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "label",
      "placeholder": "\"Bread\""
    }
  })]), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Description")]), _c('textarea', {
    attrs: {
      "name": "desc",
      "placeholder": "\"Buy me bread\""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cd60c80!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddItem.vue
// module id = 54
// module chunks = 0